import * as React from "react";
import { MMI, SectorupBar, MyDayStock } from "../../analytics";

export function StockAnalytics() {
  return (
    <div className="mt-6 w-full max-md:max-w-full">
      <div className="grid gap-3 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3">
        {/* Tablet & Desktop: MMI and SectorupBar on top, MyDayStock below */}
        <div className="bg-darkMode-layer1 rounded-xl shadow-lg col-span-1">
          <MyDayStock big={false} />
        </div>
        <div className="bg-darkMode-layer1 rounded-xl shadow-lg col-span-1">
          <SectorupBar />
        </div>
        <div className="bg-darkMode-layer1 rounded-xl shadow-lg sm:col-span-2 md:col-span1 lg:col-span-1 col-span-1">
          <MMI />
        </div>
      </div>
    </div>
  );
}
